import { useEffect, useState } from 'react';
import api from '../services/api';

export default function ArquivoPreview({ projetoid, extensao, nomeOriginal, style, onClick }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let url = null;
    api.get(`/obra-projetos/arquivo/${projetoid}`, { responseType: 'blob' })
      .then(res => {
        url = URL.createObjectURL(res.data);
        setBlobUrl(url);
      })
      .catch(() => setErro(true));

    return () => { if (url) URL.revokeObjectURL(url); };
  }, [projetoid]);

  if (erro) return (
    <div style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6', color: '#9ca3af', fontSize: 12 }}>
      Erro ao carregar
    </div>
  );

  if (!blobUrl) return (
    <div style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6' }}>
      <div style={{ width: 20, height: 20, border: '2px solid #d1d5db', borderTopColor: 'var(--azul-medio)', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
    </div>
  );

  if (['png', 'jpg', 'jpeg'].includes(extensao)) {
    return <img src={blobUrl} alt={nomeOriginal} style={style} onClick={onClick} />;
  }

  return (
    <iframe
      src={blobUrl}
      title={nomeOriginal}
      style={{ ...style, border: 'none', pointerEvents: onClick ? 'none' : 'auto' }}
    />
  );
}
